import type { Migrations } from './types/migration';
import * as migrationScripts from './migration-scripts/migrations';

/**
 * Object of all available migration scripts. Extend this object to activate more migrations.
 * The key represents the dataversion number which represents a migration
 */
export const migrations: Migrations = {
  0: migrationScripts.migration0,
  1: migrationScripts.migration1,
  2: migrationScripts.migration2,
  3: migrationScripts.migration3,
  4: migrationScripts.migration4,
  5: migrationScripts.migration5,
  6: migrationScripts.migration6,
  7: migrationScripts.migration7,
  8: migrationScripts.migration8,
  9: migrationScripts.migration9,
  10: migrationScripts.migration10,
  11: migrationScripts.migration11,
  12: migrationScripts.migration12,
  13: migrationScripts.migration13,
  14: migrationScripts.migration14,
  15: migrationScripts.migration15,
  16: migrationScripts.migration16,
  17: migrationScripts.migration17,
  18: migrationScripts.migration18,
  19: migrationScripts.migration19,
  20: migrationScripts.migration20,
  21: migrationScripts.migration21,
  22: migrationScripts.migration22,
  23: migrationScripts.migration23,
  24: migrationScripts.migration24,
  25: migrationScripts.migration25,
  26: migrationScripts.migration26,
  27: migrationScripts.migration27,
  28: migrationScripts.migration28,
  29: migrationScripts.migration29,
  30: migrationScripts.migration30,
  31: migrationScripts.migration31,
};
